import { Injectable, Inject } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Property } from './property-models';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { CORE_CONFIG } from '../environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PropertyService {

  private _baseURL: string;

  properties = new BehaviorSubject<{ [name: string]: Property }>({});

  constructor(private httpClient: HttpClient,
    private authService: AuthService,
    @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/propert`;
    this.getProperties().subscribe(ps => this.properties.next(ps));
  }

  getProperties(): Observable<{ [name: string]: Property }> {
    return this.httpClient.get<{ [name: string]: Property }>(`${this._baseURL}ies`);
  }

  updateProperties(properties: Property[]): Observable<any> {
    return this.httpClient.put(`${this._baseURL}ies`, properties);
  }
}
